import React, { Component } from 'react';
import { CardBody, Card, Label, Col, Button, Row, Input,ModalHeader,ModalBody, 
    ModalFooter } from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
    corporateCounterpartyListRequest,
    ewsBulkOptinRequest,
    bulkCrawlerStatusRequest,
    reinitiateFailedCrawlersRequest,
    ewsReportDataUploadTemplateRequest,
    ewsReportDataUploadRequest,
    ewsOptedOutReportRequest,
} from './action';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util';
import Modal from '../../components/UI/Modal/Modal';

class EWSDataUpload extends Component {

    state = {
        bulkOptinFromDate: null,
        crawlerStatusFromDate: null,
        bulkOptinToDate: null,
        crawlerStatusToDate: null,
        corporateCounterpartyListFile: null,
        ewsBulkOptinResponse: null,
        bulkOptinUploadedFile: null,
        crawlerStatusUploadedFile: null,
        reportDataUploadedFile: null,
        bulkCrawlerStatusResponse: null,
        reinitiateCrawlerResponse: null,
        ewsDataUploadTemplate: null,
        ewsDataUploadResponse: null,
        publishModal: null,
        ewsOptedOutReportResponse: null,
    };

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (this.props.corporateCounterpartyListFile !== prevProps.corporateCounterpartyListFile) {
            this.props.preloading(false);
            if (this.props.corporateCounterpartyListFile.status === "SUCCESS") {
                let statusCode = this.props.corporateCounterpartyListFile.data['status'];
                if (statusCode === 200) {
                    const data = this.props.corporateCounterpartyListFile.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Corporate_Counterparty_List"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No data available!!")
                }
            } else if (this.props.corporateCounterpartyListFile.status === "FAILURE") {
                displayErrorMessage("Plesae try again later!!")
            }
        }

        if (this.props.ewsBulkOptinResponse !== prevProps.ewsBulkOptinResponse) {
            this.props.preloading(false);
            if (this.props.ewsBulkOptinResponse.status === "SUCCESS") {
                let statusCode = this.props.ewsBulkOptinResponse.data['status'];
                if (statusCode === 200) {
                    displaySuccessMessage("EWS bulk opt-in done successfully!!");
                } else if (statusCode === 204) {
                    displayErrorMessage("No data found to bulk opt-in!!")
                }
            } else if (this.props.ewsBulkOptinResponse.status === "FAILURE") {
                let errorMessage = this.props.ewsBulkOptinResponse.data.message;
                if(errorMessage && errorMessage !== ''){
                    displayErrorMessage(errorMessage);
                }else{
                    displayErrorMessage("Plesae try again later!!");
                }                
            }
        }

        if (this.props.bulkCrawlerStatusResponse !== prevProps.bulkCrawlerStatusResponse) {
            this.props.preloading(false);
            if (this.props.bulkCrawlerStatusResponse.status === "SUCCESS") {
                let statusCode = this.props.bulkCrawlerStatusResponse.data['status'];
                if (statusCode === 200) {
                    const data = this.props.bulkCrawlerStatusResponse.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Bulk_Crawler_Status_Report"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No crawler status data found!!");
                }
            } else if (this.props.bulkCrawlerStatusResponse.status === "FAILURE") {
                displayErrorMessage("Plesae try again later!!")
            }
        }

        if (this.props.reinitiateCrawlerResponse !== prevProps.reinitiateCrawlerResponse) {
            this.props.preloading(false);
            if (this.props.reinitiateCrawlerResponse.status === "SUCCESS") {
                displaySuccessMessage("Crawlers Reinitiated Successfully!");
            } else {
                let message = this.props.reinitiateCrawlerResponse.data.message ? this.props.reinitiateCrawlerResponse.data.message : this.props.reinitiateCrawlerResponse.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.ewsDataUploadResponse !== prevProps.ewsDataUploadResponse) {
            this.props.preloading(false);
            if (this.props.ewsDataUploadResponse.status === "SUCCESS") {                
                let statusCode = this.props.ewsDataUploadResponse.data['status'];
                if(statusCode === 200) {
                    displaySuccessMessage("Data upload done successfully!");
                }else if(statusCode === 204) {
                    displayErrorMessage("No data found in the file to upload!")
                }
            } else if (this.props.ewsDataUploadResponse.status === "FAILURE") {
                let errorMessage = this.props.ewsDataUploadResponse.data;
                displayErrorMessage(errorMessage ? errorMessage : "Please Try again !!");
            }
        }

        if (this.props.ewsDataUploadTemplate !== prevProps.ewsDataUploadTemplate) {
            this.props.preloading(false);
            if (this.props.ewsDataUploadTemplate.status === "SUCCESS") {
                const data = this.props.ewsDataUploadTemplate.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"EWS_Report_Data_Upload_Template"}_${moment().format("DD_MMM_YYYY")}.xlsx`);
            } else if (this.props.ewsDataUploadTemplate.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }

        if (this.props.ewsOptedOutReportResponse != prevProps.ewsOptedOutReportResponse) {
            this.props.preloading(false);
            if (this.props.ewsOptedOutReportResponse.status === "SUCCESS") {
                displaySuccessMessage("EWS Opted Out Report Request Placed Successfully !");
            } else {
                displayErrorMessage("Error Placing EWS Opted Out Report Request !");
            }
        }
    }

    downloadCorporateCounterpartyList = () => {
        this.props.preloading(true);
        this.props.corporateCounterpartyListRequest({
            fromDate: moment(this.state.bulkOptinFromDate).format("DD-MM-YYYY"),
            toDate: moment(this.state.bulkOptinToDate).format("DD-MM-YYYY"),
        })
    }

    downloadCrawlerStatusReport = () => {
        this.props.preloading(true);
        this.props.bulkCrawlerStatusRequest({
            fromDate: moment(this.state.crawlerStatusFromDate).format("DD-MM-YYYY"),
            toDate: moment(this.state.crawlerStatusToDate).format("DD-MM-YYYY"),
        })
    }

    handleEWSReportDataUpload = (e) => {
        e.preventDefault();
        this.props.ewsReportDataUploadRequest({
            file: this.state.reportDataUploadedFile,
        })
        this.props.preloading(true);
    }

    uploadCorporateCounterpartyList = (e) => {
        e.preventDefault();
        this.props.ewsBulkOptinRequest({
            file: this.state.bulkOptinUploadedFile,
        })
        this.props.preloading(true);
    }

    uploadFileForBulkOptin = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                bulkOptinUploadedFile: file,
            });
        } else {
            this.setState({
                bulkOptinUploadedFile: undefined,
            });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
    }

    uploadFileToReinitiateCrawlers = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                crawlerStatusUploadedFile: file,
            });
        } else {
            this.setState({
                crawlerStatusUploadedFile: undefined,
            });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
    }

    uploadFileToReportDataOverride = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                reportDataUploadedFile: file,
            });
        } else {
            this.setState({
                reportDataUploadedFile: undefined,
            });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
    }

    handleBulkOptinFromDateChange = (date) => {
        this.setState({
            bulkOptinFromDate: date,
        })
    }

    handleBulkOptinToDateChange = (date) => {
        this.setState({
            bulkOptinToDate: date,
        })
    }

    handleCrawlerStatusFromDateChange = (date) => {
        this.setState({
            crawlerStatusFromDate: date,
        })
    }

    handleCrawlerStatusToDateChange = (date) => {
        this.setState({
            crawlerStatusToDate: date,
        })
    }

    handleReinitiateCrawlers = (e) => {
        e.preventDefault();
        this.props.reinitiateFailedCrawlersRequest({
            file: this.state.crawlerStatusUploadedFile,
        })
        this.props.preloading(true);
    }

    downloadEWSReportDataUploadTemplate = () => {
        this.props.preloading(true);
        this.props.ewsReportDataUploadTemplateRequest();
    }

    downloadEWSOptedOutReport = () => {
        this.setState({
            publishModal: false
        });
        console.log("Opted Out report requested!");
        this.props.preloading(true);
        this.props.ewsOptedOutReportRequest();
    }

    togglePublishModal = () => {
        this.setState({
            publishModal: true
        });
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Bulk Upload/Download</h4>
                </div>
                <Card>
                    <CardBody >
                        <Label>EWS Bulk Opt-in</Label>
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.bulkOptinFromDate}
                                    onChange={this.handleBulkOptinFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.bulkOptinToDate}
                                    onChange={this.handleBulkOptinToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.bulkOptinFromDate || !this.state.bulkOptinToDate}
                                    onClick={this.downloadCorporateCounterpartyList}>
                                    Download Corporate-Counterparty List
                                </Button>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "10px" }}>
                            <Col>
                                <Input
                                    id="upload-ews-bulk-optin-data"
                                    type="file"
                                    onChange={(e) => this.uploadFileForBulkOptin(e)}
                                    className="btn position-relative"
                                    style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button
                                    disabled={!this.state.bulkOptinUploadedFile}
                                    color="primary"
                                    style={{ width: '296px' }}
                                    onClick={e => this.uploadCorporateCounterpartyList(e)}>
                                    Upload Corporate-Counterparty List
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
                <Card>
                    <CardBody>
                    <Label>EWS Bulk Crawler Status Report</Label>
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.crawlerStatusFromDate}
                                    onChange={this.handleCrawlerStatusFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.crawlerStatusToDate}
                                    onChange={this.handleCrawlerStatusToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.crawlerStatusFromDate || !this.state.crawlerStatusToDate}
                                    onClick={this.downloadCrawlerStatusReport}>
                                    Download Crawler Status Report
                                </Button>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "10px" }}>
                            <Col>
                                <Input
                                    id="crawler-status-report-upload"
                                    type="file"
                                    onChange={(e) => this.uploadFileToReinitiateCrawlers(e)}
                                    className="btn position-relative"
                                    style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button
                                    disabled={!this.state.crawlerStatusUploadedFile}
                                    color="primary"
                                    style={{ width: '255px' }}
                                    onClick={e => this.handleReinitiateCrawlers(e)}>
                                    Re-Initiate Crawlers
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
                <Card>
                    <CardBody>
                    <Label>EWS Report Data Override</Label>                        
                        <Row style={{ paddingTop: "10px" }}>
                            <Col sm={12}>
                                <Input
                                    id="ews-report-data-override"
                                    type="file"
                                    onChange={(e) => this.uploadFileToReportDataOverride(e)}
                                    className="btn position-relative"
                                    style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button
                                    disabled={!this.state.reportDataUploadedFile}
                                    color="primary"
                                    onClick={e => this.handleEWSReportDataUpload(e)}>
                                    Override Report Data
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    onClick={this.downloadEWSReportDataUploadTemplate}>
                                    Download Template
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <div style={{padding: "20px 0 0 10px"}} className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Opted Out Data Request</h4>
                </div>
                <Card>
                    <CardBody>
                        <Row style={{ paddingTop: "10px" }}>
                                <Col sm={12}>
                                    <Button
                                        color="primary"
                                        onClick={this.togglePublishModal}>
                                        Request EWS Opted Out Report
                                    </Button>
                                </Col>
                        </Row>
                    </CardBody>
                </Card>
                {/* Publish Modal */}
                <Modal show={this.state.publishModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader className="label-text-center">EWS Opted Out Counterparties Report</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Label className="label-text-center">
                                Do You Wish To Proceed With Requesting Opted Out Counterparties Report?
                            </Label>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ publishModal: false })}>Close</Button>
                        <Button color="primary" onClick={this.downloadEWSOptedOutReport}>Confirm</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    corporateCounterpartyListFile: state.ews.corporateCounterpartyListFile,
    ewsBulkOptinResponse: state.ews.ewsBulkOptinResponse,
    bulkCrawlerStatusResponse: state.ews.bulkCrawlerStatusResponse,
    reinitiateCrawlerResponse: state.ews.reinitiateCrawlerResponse,    
    ewsDataUploadTemplate: state.ews.ewsDataUploadTemplate,
    ewsDataUploadResponse: state.ews.ewsDataUploadResponse,
    ewsOptedOutReportResponse: state.ews.ewsOptedOutReportResponse,
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    corporateCounterpartyListRequest: (data) => { dispatch(corporateCounterpartyListRequest(data)) },
    ewsBulkOptinRequest: (data) => { dispatch(ewsBulkOptinRequest(data)) },
    bulkCrawlerStatusRequest: (data) => { dispatch(bulkCrawlerStatusRequest(data)) },
    reinitiateFailedCrawlersRequest: (data) => { dispatch(reinitiateFailedCrawlersRequest(data)) },
    ewsReportDataUploadTemplateRequest: () => {dispatch(ewsReportDataUploadTemplateRequest())},
    ewsReportDataUploadRequest: (data) => {dispatch(ewsReportDataUploadRequest(data))},
    ewsOptedOutReportRequest: () => {dispatch(ewsOptedOutReportRequest())},
});


export default connect(mapStateToProps, mapDispatchToProps)(EWSDataUpload);